import { render } from "./QueueMessageViewer.vue?vue&type=template&id=3186ef09"
import script from "./QueueMessageViewer.vue?vue&type=script&lang=js"
export * from "./QueueMessageViewer.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__